<template>
  <main>
    <!-- BANNER -->
    <RysBanner2
      :page="page"
      :links="links"
      :mobilebanner="true"
    />

    <router-view />
  </main>
</template>

<script setup>
import yoastToVueMeta from '@/utils/yoast-to-vue-meta';

const wpJson = useWp();

const { data: page, error: pageError } = await useAsyncData(
  'page-campus-improvement-grant',
  () => wpJson.pages.getBySlug('campus-improvement-grant')
);

if (pageError.value) {
  throw createError({ status: 500, cause: pageError.value });
}

if (!page.value) {
  throw createError({ statusCode: 404 });
}

const { data: subpages, error: subpagesError } = await useAsyncData(
  'campus-improvement-grant-subpages',
  () => wpJson.pages.getPagePreviewsByParentId(page.value.id)
);

if (subpagesError.value) {
  throw createError({ status: 500, cause: subpagesError.value });
}

const links = computed(() => {
  const linksArray = [];

  if (subpages.value && subpages.value.length > 0) {
    const subpageLinks = subpages.value.map((subpage) => ({
      title: subpage.title.rendered,
      url: subpage.link,
      order: subpage.menu_order,
      slug: subpage.slug
    }));

    linksArray.push(...subpageLinks);
  }

  // Always place the "overview" subpage first, then sort the rest by menu_order
  return linksArray.sort((a, b) => {
    if (a.slug === 'overview')
      return -1;
    if (b.slug === 'overview')
      return 1;
    return a.order - b.order;
  });
});

useHead(yoastToVueMeta(page.value));
</script>

<style lang="scss" scoped>
</style>
